module.exports = ".current-one {\n  background-color: #fff !important;\n  border-right: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/seller/safetybox/safetybox.component.scss
// module id = ./src/app/seller/safetybox/safetybox.component.scss
// module chunks = main